export const hasOngoingAction = (
  showHint: boolean,
  showAnimation: boolean,
  isAudioPlaying: boolean
): boolean => showHint || isAudioPlaying || showAnimation;
